module.exports = __webpack_public_path__ + "25e280e9608df14c1b6a188523b3148f.png";